module.exports = __webpack_public_path__ + "static/media/1POLICY44.f2c9afd7.jpg";